// ============================================================
// Academic Session Service
// ============================================================

import { academicSessionsApi } from '@/api/academicSessions.api';

const academicSessionService = {
  createSession: async (data) => {
    return await academicSessionsApi.create(data);
  },

  getSessionsBySchool: async (schoolId) => {
    return await academicSessionsApi.getAllBySchool(schoolId);
  },

  getCurrentSession: async (schoolId) => {
    return await academicSessionsApi.getCurrentBySchool(schoolId);
  },

  getSessionById: async (id) => {
    return await academicSessionsApi.getById(id);
  },

  updateSession: async (id, data) => {
    return await academicSessionsApi.update(id, data);
  },

  setSessionCurrent: async (id) => {
    return await academicSessionsApi.setCurrent(id);
  },

  updateSessionStatus: async (id, status) => {
    return await academicSessionsApi.updateStatus(id, status);
  }
};

export default academicSessionService;
